( function( $ ){
    
    let posts = ThemeJS.Variables.posts;

    // Fetch vocations posts
    function load_page ( page ) {
        ThemeJS.Functions.send_ajax_request({
            data:{
                action: 'get_vocations',
                page: page
            },
            success: ( data ) => {
                $( '.pagination' ).html( data.pagination );
                $( '.vocation-posts-container' ).html( data.content );
                posts = data.posts;
                $( '.select-vocation' ).eq(0).click();
            }
        });
    }

    $( document ).on( 'click', '.pagination a', function( e ){
        e.preventDefault();
        load_page( get_page_parameter( this ) );
    });

    // Select a Single Issue
    $( document ).on( 'click', '.select-vocation', function( e ){
        e.preventDefault();
        let post_id = $( this ).attr( 'data-id' );
        set_active_post( post_id );
    });

    function get_page_parameter( element ){
        let page = ThemeJS.Functions.QueryParams.get( 'paged', $( element ).attr( 'href' ) );
        if( ! page ){
            let href = $( element ).attr('href');
            let after_page = href.substring( href.indexOf( '/page/' ) + 6 );
            page = after_page.substring( 0, after_page.indexOf( '/' ) );
        }
        return page;
    }

    function set_active_post( post_id ){
        let post = posts[ post_id ];
        let $viewbox = $( '.vocations-viewbox' );
        if ( typeof DFLIP != 'undefined' ) {
            $viewbox.find( '.preview' ).html( post.flipbook );
            DFLIP.parseBooks();
            $('html, body').animate(
                { scrollTop: $( '.vocations-viewbox' ).offset().top - 50 },
                1000
            );
        }
        $viewbox.find( '.issue-date' ).html( `${ post.issue_date.season } ${ post.issue_date.year } Issue` );
        $viewbox.find( '.issue-description' ).html( post.description );
        $viewbox.find( '.download-issue' ).attr( 'href', post.file );
        $viewbox.attr( 'data-id', post_id );
        $( '.select-vocation').removeClass( 'active' );
        $( '.select-vocation[data-id="'+ post_id +'"').addClass( 'active' );
    }

    // Select First Post
    $( '.select-vocation' ).eq(0).click();

})( jQuery );